var React = require('react');

function IconScales (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"8.92969","width":"33.5528","height":"24.0705","rx":"2.18823","stroke":"#FFE768","strokeWidth":"2.55293","key":0}),React.createElement("circle",{"cx":"18.777","cy":"8.92939","r":"6.92939","fill":"#F5F8F2","stroke":"#6CE4BF","strokeWidth":"2.18823","key":1}),React.createElement("path",{"d":"M17.9688 4.83203L19.2148 10.1086","stroke":"#5DA7EB","strokeWidth":"1.82352","key":2})]);
}

IconScales.defaultProps = {"width":"37","height":"35","viewBox":"0 0 37 35","fill":"none"};

module.exports = IconScales;

IconScales.default = IconScales;
